import { useRef, useCallback } from "react";

const useThrottle = <T extends (...args: any[]) => void>(callback: T, delay: number): T => {
    const lastCalled = useRef(0);

    const throttled = useCallback((...args: Parameters<T>) => {
        const now = Date.now();

        if (now - lastCalled.current >= delay) {
            lastCalled.current = now;
            callback(...args);
        }
    }, [callback, delay]);

    return throttled as T;
};

export default useThrottle;